import classnames from 'classnames';
import Overlay from 'components/Modal/Overlay';
import React, { useRef } from 'react';

import Handle from './Handle';

const CSS = require('./Sheet.module.scss');

interface SheetProps {
  show: boolean;
  onClose: () => void;
  className?: string;
  overlayClassName?: string;
  children: any;
  portalId?: string;
}

function Sheet({
  show,
  onClose,
  className,
  overlayClassName,
  children,
  portalId,
}: SheetProps) {
  const clickableDialog: any = useRef(null);
  if (!show) {
    return null;
  }

  const closeSheet = () => {
    if (!!onClose && show) {
      onClose();
    }
  };

  const sheetClick = (event) => {
    if (clickableDialog && !clickableDialog.current.contains(event.target)) {
      closeSheet();
    }
  };

  return (
    <Overlay
      onEsc={closeSheet}
      className={overlayClassName}
      onClick={sheetClick}
      portalId={portalId || 'sheetPortal'}
    >
      <>
        <Handle />
        <dialog
          ref={clickableDialog}
          className={classnames(CSS.Sheet, { [className]: className })}
        >
          {children}
        </dialog>
      </>
    </Overlay>
  );
}

export default Sheet;
